import Auth from 'components/auth/main/containers/AuthContainer';
import PasswordRecoveryContainer from 'components/auth/passwordRecovery/containers/PasswordRecoveryContainer';
import RecoverySuccess from 'components/auth/recoverySuccess/presentational/RecoverySuccess';

export default [
    { path: 'login', component: Auth, pageTitle: 'Login' },
    {
        path: 'forgotten-password',
        component: PasswordRecoveryContainer,
        pageTitle: 'Forgotton Password',
    },
    {
        path: 'recovery-success',
        component: RecoverySuccess,
        pageTitle: 'Password Recovery Success',
    },
];
